import window, { ResizeObserver, ResizeObserverCallback, ResizeObserverEntry } from 'bits/global'
type CallbackFunctionType = (element: HTMLElement, contentRect: DOMRectReadOnly) => void
const canObserveSizeChange = true
let MyResizeObserver: ResizeObserver | undefined = window.ResizeObserver

if (!MyResizeObserver) {
  class CustomResizeObserver {
    private callback: ResizeObserverCallback
    private target: Element | null
    private mutationObserver: MutationObserver
    public constructor(callback: ResizeObserverCallback) {
      this.callback = callback
      this.target = null
      this.mutationObserver = new MutationObserver((): void => {
        const fakeEntry = ({
          target: this.target,
          contentRect: this.target && this.target.getBoundingClientRect(),
        } as unknown) as ResizeObserverEntry
        this.callback([fakeEntry], (this as unknown) as ResizeObserver)
      })
    }

    public observe(someElement: Element): void {
      const mutationObserverConfig = { subtree: true, childList: true }
      this.target = someElement
      this.mutationObserver.observe(someElement, mutationObserverConfig)
    }

    public disconnect(): void {
      this.mutationObserver.disconnect()
    }
  }
  MyResizeObserver = CustomResizeObserver as ResizeObserver
}

/**
 * Observe the visibility of a dom element and call a function when visibile.
 * Returns false if resize observer is not supported by the browser.
 * @param element The dom element to observe the resize of
 * @param callback The method to call
 */
function observerSizeChange(element: HTMLElement, callback: CallbackFunctionType): ResizeObserver | null {
  if (canObserveSizeChange) {
    const resizeObserver = new window.ResizeObserver((entries: ResizeObserverEntry[]): void => {
      entries.forEach((entry: ResizeObserverEntry): void => {
        if (entry.contentRect) {
          callback(element, entry.contentRect)
        }
      })
    })
    resizeObserver.observe(element)
    return resizeObserver
  }
  return null
}

export { observerSizeChange, canObserveSizeChange }
export default MyResizeObserver
